export const USER_INFO_REQUEST = 'USER_INFO_REQUEST';
export const USER_INFO_REQUEST_SUCCESS = 'USER_INFO_REQUEST_SUCCESS';
export const USER_INFO_REQUEST_ERROR = 'USER_INFO_REQUEST_ERROR';
export const USER_INFO_CLEAR = 'USER_INFO_CLEAR';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
